import GenericLink from './GenericLink';
import { getNonRecordPageHref } from './getRecordHref';
import { jsx as _jsx } from "react/jsx-runtime";
const NonRecordPageLink = ({
  children,
  external,
  handleClick,
  hideIfNotSupported,
  includeEschref,
  LinkComponent,
  LinkComponentProps,
  objectId,
  objectTypeId
}) => {
  const href = getNonRecordPageHref(objectTypeId, objectId, {
    includeEschref
  });
  if (!href) {
    return hideIfNotSupported ? null : /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(GenericLink, {
    dataSpeculationTarget: "crm-links-CRM_OBJECT_RECORD",
    external: external,
    href: href,
    LinkComponent: LinkComponent,
    LinkComponentProps: LinkComponentProps,
    onClick: handleClick,
    children: children
  });
};
export default NonRecordPageLink;